<div class="planning-container">
  <div class="toolbar">
    <div class="title-block">
      <mat-icon>event_available</mat-icon>
      <h1>Ressourcenplanung</h1>
    </div>

    <div class="view-toggle">
      <button mat-button [class.active]="viewMode === 'week'" (click)="setView('week')">Woche</button>
      <button mat-button [class.active]="viewMode === 'month'" (click)="setView('month')">Monat</button>
      <button mat-button [class.active]="viewMode === 'year'" (click)="setView('year')">Jahr</button>
    </div>

    <div class="nav-block">
      <button mat-stroked-button (click)="today()">Heute</button>
      <button mat-icon-button (click)="prev()" matTooltip="Zurück"><mat-icon>chevron_left</mat-icon></button>
      <span class="period-label">{{ periodLabel }}</span>
      <button mat-icon-button (click)="next()" matTooltip="Weiter"><mat-icon>chevron_right</mat-icon></button>
      <input class="jump-date" type="date" [ngModel]="jumpDateValue"
             (ngModelChange)="setJumpDate($event)" matTooltip="Zu Datum springen" />
      <button mat-stroked-button (click)="openAvailability()" matTooltip="Freien Mitarbeiter finden">
        <mat-icon>person_search</mat-icon> Verfügbarkeit
      </button>
      <button mat-icon-button (click)="print()" matTooltip="Plan drucken"><mat-icon>print</mat-icon></button>
      <button mat-stroked-button *ngIf="hiddenExternalCount > 0"
              [color]="showHiddenExternal ? 'primary' : undefined"
              (click)="toggleHiddenExternal()"
              [matTooltip]="showHiddenExternal ? 'Ausgeblendete Sync-Termine verbergen' : 'Ausgeblendete Sync-Termine anzeigen'">
        <mat-icon>{{ showHiddenExternal ? 'visibility' : 'visibility_off' }}</mat-icon>
        {{ hiddenExternalCount }} ausgeblendet
      </button>
      <button *ngIf="isSuperAdmin" mat-stroked-button color="primary" (click)="openManagement()">
        <mat-icon>manage_accounts</mat-icon> Verwalten
      </button>
    </div>
  </div>

  <mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>

  <!-- Filterleiste -->
  <div class="filterbar" *ngIf="viewMode !== 'year'">
    <mat-form-field appearance="outline" subscriptSizing="dynamic" class="filter-text">
      <mat-icon matPrefix>search</mat-icon>
      <input matInput placeholder="Suche (Titel, Kunde, Ort…)"
             [(ngModel)]="filterText" (ngModelChange)="applyFilter()" />
    </mat-form-field>

    <mat-form-field appearance="outline" subscriptSizing="dynamic" class="filter-select">
      <mat-label>Kategorie</mat-label>
      <mat-select multiple [(ngModel)]="filterCategoryIds" (ngModelChange)="applyFilter()">
        <mat-option *ngFor="let c of categories" [value]="c.id">
          <span class="dot" [style.background]="c.color"></span>{{ c.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" subscriptSizing="dynamic" class="filter-select">
      <mat-label>Skill</mat-label>
      <mat-select multiple [(ngModel)]="filterSkillIds" (ngModelChange)="applyFilter()">
        <mat-option *ngFor="let s of allSkills()" [value]="s.id">
          <span class="dot" [style.background]="s.color"></span>{{ s.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <button mat-button *ngIf="filterActive" (click)="clearFilter()">
      <mat-icon>clear</mat-icon> Filter zurücksetzen
    </button>

    <span class="filter-spacer"></span>

    <div class="color-mode">
      <span class="cm-label">Einfärben nach:</span>
      <div class="view-toggle small">
        <button mat-button [class.active]="colorMode === 'category'" (click)="setColorMode('category')">Kategorie</button>
        <button mat-button [class.active]="colorMode === 'customer'" (click)="setColorMode('customer')">Kunde</button>
        <button mat-button [class.active]="colorMode === 'status'" (click)="setColorMode('status')">Status</button>
      </div>
    </div>
  </div>

  <!-- Legende Kategorien + Symbole -->
  <div class="legend" *ngIf="viewMode !== 'year'">
    <ng-container *ngIf="categories.length">
      <span class="legend-item" *ngFor="let c of categories">
        <span class="dot" [style.background]="c.color"></span>{{ c.name }}
      </span>
      <span class="legend-sep"></span>
    </ng-container>
    <span class="legend-item"><mat-icon class="leg-ic">group</mat-icon>Team</span>
    <span class="legend-item"><mat-icon class="leg-ic">repeat</mat-icon>Serie</span>
    <span class="legend-item"><mat-icon class="leg-ic">directions_car</mat-icon>Reisezeit</span>
    <span class="legend-item"><mat-icon class="leg-ic">hourglass_empty</mat-icon>Antrag offen</span>
    <span class="legend-item"><mat-icon class="leg-ic">warning</mat-icon>Konflikt</span>
    <span class="legend-item"><mat-icon class="leg-ic">mail</mat-icon>Einladung</span>
    <span class="legend-spacer"></span>
    <span class="legend-hint" matTooltip="Tastatur: ← → blättern · T heute · W/M/J Ansicht">
      <mat-icon class="leg-ic">keyboard</mat-icon>← → · T · W/M/J
    </span>
  </div>

  <!-- ===== Woche / Monat ===== -->
  <div class="grid-wrapper" *ngIf="viewMode !== 'year'">
    <div class="cal" [class.month-view]="viewMode === 'month'" [class.bar-dragging]="isBarDragging()"
         [style.min-width.px]="minGridWidth">

      <!-- Kopfzeile -->
      <div class="cal-header"
           [style.grid-template-columns]="'220px repeat(' + days.length + ', minmax(0, 1fr))'">
        <div class="cell head corner">Mitarbeiter</div>
        <div class="cell head day-head"
             *ngFor="let day of days"
             [class.today]="isToday(day)"
             [class.weekend]="isWeekend(day)">
          <span class="weekday">{{ weekdayShort[day.getDay()] }}</span>
          <span class="daydate">{{ day | date:(viewMode === 'week' ? 'dd.MM.' : 'dd') }}</span>
        </div>
      </div>

      <!-- Mitarbeiter-Zeilen -->
      <div class="user-row"
           *ngFor="let user of users"
           [class.user-dimmed]="isUserDimmed(user)"
           [style.grid-template-columns]="'220px 1fr'"
           [style.min-height.px]="rowHeight(user.id)">
        <div class="cell user-cell">
          <div class="user-top">
            <span class="user-name">{{ user.name }}</span>
            <mat-icon class="overload-icon" *ngIf="hasOverload(user)"
                      matTooltip="Überlastet (über 100%)">warning</mat-icon>
            <span class="util-badge" [style.background]="utilizationColor(utilization(user))"
                  [matTooltip]="utilizationTooltip(user)">{{ utilization(user) }}%</span>
          </div>
          <div class="skill-chips" *ngIf="user.skills?.length">
            <span class="chip" *ngFor="let s of user.skills" [style.background]="s.color">{{ s.name }}</span>
          </div>
        </div>

        <!-- Spur: Tageshintergrund (Linien + Drag) und darüber die Balken -->
        <div class="track">
          <div class="track-bg"
               [style.grid-template-columns]="'repeat(' + days.length + ', minmax(0, 1fr))'">
            <div class="day-bg"
                 *ngFor="let day of days; let i = index"
                 [class.today]="isToday(day)"
                 [class.weekend]="isWeekend(day)"
                 [class.drag-sel]="isInDragSelection(user.id, i)"
                 (mousedown)="onCellMouseDown(user, i, $event)"
                 (mouseenter)="onCellMouseEnter(user, i)"></div>
          </div>

          <div class="bar"
               *ngFor="let b of userBars[user.id]"
               [class.conflict]="b.conflict"
               [class.dimmed]="b.dimmed"
               [class.done]="b.done"
               [class.mirror]="b.isMirror"
               [class.pending]="b.approvalPending"
               [class.rejected]="b.approvalRejected"
               [class.flying]="isDraggedBar(b)"
               [style.left.%]="b.leftPct"
               [style.width.%]="b.widthPct"
               [style.top.px]="b.top"
               [style.transform]="draggedBarTransform(b)"
               [style.background]="b.color"
               [style.color]="b.textColor"
               [matTooltip]="b.tooltip"
               (mousedown)="onBarMouseDown(b, user, $event)">
            <div class="bar-handle left" (mousedown)="onBarHandleMouseDown(b, user, 'start', $event)"></div>
            <span class="status-dot" [style.background]="b.statusColor"
                  [matTooltip]="b.statusLabel + ' – klicken für nächsten Status'"
                  (mousedown)="$event.stopPropagation()" (click)="advanceStatus(b, $event)"></span>
            <span class="bar-label" *ngIf="b.showLabel">
              <mat-icon class="conflict-icon" *ngIf="b.approvalPending" matTooltip="Abwesenheit beantragt">hourglass_empty</mat-icon>
              <mat-icon class="conflict-icon" *ngIf="b.approvalRejected" matTooltip="Antrag abgelehnt">block</mat-icon>
              <mat-icon class="conflict-icon" *ngIf="b.conflict">warning</mat-icon>
              <mat-icon class="wrench-icon" *ngIf="b.isMirror" matTooltip="Team-Termin (verantwortlich: anderer)">group</mat-icon>
              <mat-icon class="wrench-icon" *ngIf="b.assignment.maintenanceId"
                        matTooltip="Mit Wartungsauftrag verknüpft">build</mat-icon>
              <mat-icon class="wrench-icon" *ngIf="b.assignment.seriesId"
                        matTooltip="Teil einer Serie">repeat</mat-icon>
              <mat-icon class="wrench-icon" *ngIf="hasTravel(b.assignment)"
                        matTooltip="Mit Reisezeit-Puffer">directions_car</mat-icon>
              {{ b.assignment.title }}<span class="bar-time"> · {{ b.timeLabel }}</span>
            </span>
            <mat-icon class="a-sent" *ngIf="b.assignment.inviteSent"
                      matTooltip="Outlook-Einladung versendet">mail</mat-icon>

            <span class="bar-actions" *ngIf="viewMode === 'week'">
              <mat-icon class="ba-icon ba-ok" *ngIf="b.approvalPending" matTooltip="Genehmigen"
                        (mousedown)="$event.stopPropagation()" (click)="approveAbsence(b, $event)">check</mat-icon>
              <mat-icon class="ba-icon ba-no" *ngIf="b.approvalPending" matTooltip="Ablehnen"
                        (mousedown)="$event.stopPropagation()" (click)="rejectAbsence(b, $event)">close</mat-icon>
              <mat-icon class="ba-icon" matTooltip="Status weiter"
                        (mousedown)="$event.stopPropagation()" (click)="advanceStatus(b, $event)">arrow_forward</mat-icon>
              <mat-icon class="ba-icon" matTooltip="Duplizieren"
                        (mousedown)="$event.stopPropagation()" (click)="duplicate(b, $event)">content_copy</mat-icon>
              <mat-icon class="ba-icon" matTooltip="Bearbeiten"
                        (mousedown)="$event.stopPropagation()" (click)="openEdit(b.assignment, $event)">edit</mat-icon>
              <mat-icon class="ba-icon" matTooltip="Einladung senden"
                        (mousedown)="$event.stopPropagation()" (click)="sendInviteQuick(b, $event)">mail</mat-icon>
            </span>

            <div class="bar-handle right" (mousedown)="onBarHandleMouseDown(b, user, 'end', $event)"></div>
          </div>

          <!-- Externe (geteilte) Kalendertermine – Klick übernimmt sie in die Planung -->
          <div class="ext-bar"
               [class.ext-hidden]="x.hidden"
               *ngFor="let x of userExtBars[user.id]"
               [style.left.%]="x.leftPct"
               [style.width.%]="x.widthPct"
               [style.top.px]="x.top"
               [matTooltip]="x.tooltip"
               (mousedown)="$event.stopPropagation()"
               (click)="onExtBarClick(x, $event)">
            <mat-icon class="ext-add">{{ x.hidden ? 'visibility' : 'add' }}</mat-icon>
            <span class="ext-label" *ngIf="x.showLabel">{{ x.title }}</span>
            <mat-icon class="ext-hide-btn" *ngIf="!x.hidden && viewMode === 'week'"
                      matTooltip="Diesen Sync-Termin ausblenden"
                      (mousedown)="$event.stopPropagation()" (click)="hideExternal(x, $event)">visibility_off</mat-icon>
          </div>

          <!-- Jetzt-Linie -->
          <div class="now-line" *ngIf="nowLinePct !== null" [style.left.%]="nowLinePct"></div>
        </div>
      </div>

      <div class="empty-row" *ngIf="!loading && users.length === 0">
        Keine planbaren Benutzer. <span *ngIf="isSuperAdmin">Über „Verwalten" Benutzer aktivieren.</span>
      </div>
    </div>
  </div>

  <!-- ===== Jahr ===== -->
  <div class="grid-wrapper" *ngIf="viewMode === 'year'">
    <div class="grid year-grid" [style.grid-template-columns]="'220px repeat(12, 1fr)'">
      <div class="cell head corner">Mitarbeiter</div>
      <div class="cell head month-head" *ngFor="let m of months">{{ monthShort[m.getMonth()] }}</div>

      <ng-container *ngFor="let user of users">
        <div class="cell user-cell">
          <div class="user-top"><span class="user-name">{{ user.name }}</span></div>
          <div class="skill-chips" *ngIf="user.skills?.length">
            <span class="chip" *ngFor="let s of user.skills" [style.background]="s.color">{{ s.name }}</span>
          </div>
        </div>
        <div class="cell month-cell"
             *ngFor="let m of months"
             [style.background]="utilizationColor(monthStats(user, m).percent)"
             [matTooltip]="monthStats(user, m).count + ' Termine'"
             (click)="openMonthFromYear(m)">
          <span class="m-percent" *ngIf="monthStats(user, m).count > 0">{{ monthStats(user, m).percent }}%</span>
        </div>
      </ng-container>

      <div class="cell empty-row" *ngIf="!loading && users.length === 0">
        Keine planbaren Benutzer.
      </div>
    </div>
  </div>

  <p class="hint">
    Tipp: Leeren Bereich über mehrere Tage ziehen = neuer Termin. Bestehenden Termin ziehen = verschieben
    (auch auf andere Mitarbeiter); an den Rändern ziehen = Dauer ändern. Anklicken zum Bearbeiten.
    Rote Umrandung = zeitlicher Konflikt. In der Jahresansicht zeigt die Farbe die Auslastung – Klick öffnet den Monat.
  </p>
</div>
